import classnames from 'classnames';

import {colors} from '../../../../colors/colors';
import {MarketingAutomationIcon} from '../../../../icon/svg/marketing-automation-icon';
import {DurationTimestamp} from '../../../../timestamp/duration-timestamp';

import styles from './session-page-item.module.css';

type MaUrl = {
    id: string;
    name: string;
};

export type SessionPage = {
    id: string;
    durationSeconds: number;
    path: string | null | undefined;
    pageTitle: string | null | undefined;
    fullyQualifiedUrl: string | null | undefined;
    maUrl: MaUrl | null | undefined;
};

type Props = {
    page: SessionPage;
};

export function SessionPageItem(props: Props) {
    const {page} = props;
    const hasMaUrl = Boolean(page.maUrl);

    const innerContents = (
        <>
            <div className={styles['page-info']}>
                <div>
                    <div>{page.path ? page.path : <i>Unknown page</i>}</div>
                    <div className={styles['page-title']}>
                        {page.pageTitle ? page.pageTitle : <i>No page title</i>}
                    </div>
                    {page.maUrl ? (
                        <div className={styles['ma-url-label']}>
                            <MarketingAutomationIcon
                                size={14}
                                // @ts-expect-error
                                fill={colors.secondarySidebarHoverBlue}
                                wrapWithDiv={false}
                            />
                            <span>•</span>
                            <span>{page.maUrl.name}</span>
                        </div>
                    ) : null}
                </div>
            </div>
            <DurationTimestamp durationSeconds={page.durationSeconds} />
        </>
    );

    if (page.fullyQualifiedUrl) {
        return (
            <a
                rel='noreferrer noopener'
                target='_blank'
                href={page.fullyQualifiedUrl}
                className={
                    hasMaUrl
                        ? classnames(styles['page-item'], styles['page-item--ma-url'])
                        : styles['page-item']
                }
            >
                {innerContents}
            </a>
        );
    }

    return (
        <div
            className={
                hasMaUrl
                    ? classnames(styles['page-item'], styles['page-item--ma-url'])
                    : styles['page-item']
            }
        >
            {innerContents}
        </div>
    );
}
